import PageMappersFactory from '../../page/Mappers/factory.js'
import UserRepositoriesFactory from '../../user/Repositories/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import TrackingMappersFactory from '../Mappers/factory.js'
import TrackingRepositoriesFactory from '../Repositories/factory.js'
import TrackingValueObjectsFactory from '../ValueObjects/factory.js'
import {GetAdvertisementsTrackingService} from './GetAdvertisementsTrackingService.js'
import {GetEventTrackingDataService} from './GetEventTrackingDataService.js'
import {GetIdentifyTrackingDataService} from './GetIdentifyTrackingDataService.js'
import {GetLeadDataTrackingService} from './GetLeadDataTrackingService.js'
import {GetPageTrackingDataService} from './GetPageTrackingDataService.js'
import {GetResetTrackingDataService} from './GetResetTrackingDataService.js'
import {SavePageViewHitTrackingService} from './SavePageViewHitTrackingService.js'

export default class TrackingServicesFactory {
  static getPageTrackingDataService = ({config}) => {
    return new GetPageTrackingDataService({
      config,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      trackingProxyMapper: TrackingMappersFactory.trackingProxyMapper({
        config
      }),
      fromPageNameToConstantNamingPageName: PageMappersFactory.fromPageNameToConstantNamingPageName(),
      getResetTrackingDataService: TrackingServicesFactory.getResetTrackingDataService({config}),
      getIdentifyTrackingDataService: TrackingServicesFactory.getIdentifyTrackingDataService({
        config
      }),
      valueObject: TrackingValueObjectsFactory.trackingDataValueObject
    })
  }

  static getEventTrackingDataService = ({config}) => {
    return new GetEventTrackingDataService({
      getResetTrackingDataService: TrackingServicesFactory.getResetTrackingDataService({config}),
      getIdentifyTrackingDataService: TrackingServicesFactory.getIdentifyTrackingDataService({
        config
      }),
      fromEventTrackingDataToEventTrackingDataValueObjectMapper:
        TrackingMappersFactory.fromEventTrackingDataToEventTrackingDataValueObjectMapper({config})
    })
  }

  static getResetTrackingDataService = ({config}) => {
    return new GetResetTrackingDataService({
      cookieRepository: UserRepositoriesFactory.cookieUserRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      repository:
        typeof window !== 'undefined'
          ? TrackingRepositoriesFactory.sessionStorageRepository({config})
          : TrackingRepositoriesFactory.emptyTrackingRepository({
              config
            })
    })
  }

  static getIdentifyTrackingDataService = ({config}) => {
    return new GetIdentifyTrackingDataService({
      config,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      identifyMapper: TrackingMappersFactory.identifyMapper({config}),
      repository:
        typeof window !== 'undefined'
          ? TrackingRepositoriesFactory.sessionStorageRepository({config})
          : TrackingRepositoriesFactory.emptyTrackingRepository({
              config
            })
    })
  }

  static getAdvertisementsTrackingService = ({config}) =>
    new GetAdvertisementsTrackingService({
      fromPageTrackingJsonToAdvertisementsValueObjectMapper:
        TrackingMappersFactory.fromPageTrackingJsonToAdvertisementsValueObjectMapper({config})
    })

  static getLeadDataTrackingService = ({config}) =>
    new GetLeadDataTrackingService({
      config,
      trackingLeadMapper: TrackingMappersFactory.trackingLeadMapper({
        config
      }),
      getAdvertisementsTrackingService: TrackingServicesFactory.getAdvertisementsTrackingService({config})
    })

  static savePageViewHitTrackingService = ({config}) =>
    new SavePageViewHitTrackingService({
      config,
      httpTrackingRepository: TrackingRepositoriesFactory.httpTrackingRepository({
        config
      })
    })
}
